<template>
  <li
    v-if="canViewVerticalNavMenuGroup(item) && item.visible"
    class="nav-item has-sub"
    :class="{
      open: isOpen,
      disabled: item.disabled,
      'sidebar-group-active': isActive,
    }"
  >
    <b-link
      class="d-flex align-items-center"
      :class="{ 'childtitlestyle': Boolean(!item.customicon && !item.icon && !item.komicon), 'is-level-3-group': item.children[0].isLevel3 }"
      @click="() => updateGroupOpen(!isOpen)"
    >
      <div
        v-if="item.customicon"
        v-html="item.customicon"
      />
      <span
        v-else-if="item.komicon"
        :class="item.komicon"
        style="margin-right: 1.1rem; font-size: 1.5rem;"
      />
      <feather-icon
        v-else
        :icon="item.icon || (item.hasParent ? '' : 'CircleIcon')"
      />
      <span
        class="menu-title text-truncate"
        :class="{ 'font-bold text-black': Boolean(item.fontBold) }"
      >{{ t(item.title) }}</span>
      <b-badge
        v-if="item.tag"
        pill
        :variant="item.tagVariant || 'primary'"
        class="mr-1 ml-auto"
      >
        {{ item.tag }}
      </b-badge>
      <b-badge
        v-if="item.title === 'Komads' && $store.state.komadsWhitelist.accumulationNotification > 0"
        pill
        variant="primary"
        class="ml-1"
      >
        {{ $store.state.komadsWhitelist.accumulationNotification }}
      </b-badge>
    </b-link>
    <b-collapse
      v-model="isOpen"
      class="menu-content"
      tag="ul"
    >
      <component
        :is="resolveNavItemComponent(child)"
        v-for="child in item.children"
        :key="child.header || child.title"
        ref="groupChild"
        :item="child"
      />
    </b-collapse>
  </li>
</template>

<script>
import { BLink, BBadge, BCollapse } from 'bootstrap-vue'
import { resolveVerticalNavMenuItemComponent as resolveNavItemComponent } from '@core/layouts/utils'
import { useUtils as useI18nUtils } from '@core/libs/i18n'
import { useUtils as useAclUtils } from '@core/libs/acl'
import VerticalNavMenuHeader from '../vertical-nav-menu-header'
import VerticalNavMenuLink from '../vertical-nav-menu-link/VerticalNavMenuLink.vue'

// Composition Function
import useVerticalNavMenuGroup from './useVerticalNavMenuGroup'
import mixinVerticalNavMenuGroup from './mixinVerticalNavMenuGroup'

export default {
  name: 'VerticalNavMenuGroup',
  components: {
    VerticalNavMenuHeader,
    VerticalNavMenuLink,
    BLink,
    BBadge,
    BCollapse,
  },
  mixins: [mixinVerticalNavMenuGroup],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const {
      isOpen,
      isActive,
      updateGroupOpen,
      updateIsActive,
    } = useVerticalNavMenuGroup(props.item)

    const { t } = useI18nUtils()
    const { canViewVerticalNavMenuGroup } = useAclUtils()

    return {
      resolveNavItemComponent,
      isOpen,
      isActive,
      updateGroupOpen,
      updateIsActive,

      // ACL
      canViewVerticalNavMenuGroup,

      // i18n
      t,
    }
  },
}
</script>

<style>
</style>
